import { render } from "./figth.vue?vue&type=template&id=87a6ffa8&scoped=true"
import script from "./figth.vue?vue&type=script&lang=js"
export * from "./figth.vue?vue&type=script&lang=js"

import "./figth.vue?vue&type=style&index=0&id=87a6ffa8&scoped=true&lang=css"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87a6ffa8"]])

export default __exports__